export const menuSections = [
  {
    id: 'signatures',
    label: 'Signatures',
    items: [
      {
        name: 'Cranberry Coffee',
        desc: 'Espresso with cranberry juice and sweet aerated water. The drink that started it all — lactose free.',
        price: 248,
        tag: 'Iconic',
        veg: true,
      },
      {
        name: 'Brownie Blend Coffee',
        desc: 'Double shot espresso blended with ice cream and brownie. Rich, indulgent, deeply satisfying.',
        price: 348,
        tag: 'Iconic',
        veg: false,
      },
      {
        name: 'Nutella Blend Cold Coffee',
        desc: 'Light roast Arabica espresso blended with Nutella and vanilla ice cream. Smooth and creamy.',
        price: 320,
        tag: 'Iconic',
        veg: true,
      },
      {
        name: 'Cold Brew Cascara',
        desc: 'Dried coffee cherry husks cold-brewed for 24 hours. Sweet, fruity, and unlike anything else.',
        price: 280,
        tag: 'Rare',
        veg: true,
      },
      {
        name: 'Nitro Cold Brew',
        desc: 'Cold brew infused with nitrogen for a silky, creamy texture. Served like a draught beer.',
        price: 310,
        tag: 'Rare',
        veg: true,
      },
    ],
  },
  {
    id: 'cold-brew',
    label: 'Cold Brew',
    items: [
      {
        name: 'Classic Cold Brew',
        desc: '18-hour slow-steeped cold brew. Smooth, low-acid, and deeply flavoured.',
        price: 230,
        veg: true,
      },
      {
        name: 'Cold Brew Tonic',
        desc: 'Cold brew poured over sparkling tonic water. Effervescent and bold.',
        price: 260,
        tag: 'New',
        veg: true,
      },
      {
        name: 'Cold Brew Float',
        desc: 'Cold brew topped with a scoop of vanilla ice cream. A dessert and a drink in one.',
        price: 290,
        veg: true,
      },
      {
        name: 'Aam Pana Mojito',
        desc: 'Raw mango cooler with mint and a hint of spice. A seasonal Indian summer classic.',
        price: 228,
        tag: 'Seasonal',
        veg: true,
      },
    ],
  },
  {
    id: 'hot-coffee',
    label: 'Hot Coffee',
    items: [
      {
        name: 'Cappuccino',
        desc: 'Espresso with frothed milk — equal parts steamed milk and foam. A classic done right.',
        price: 220,
        veg: true,
      },
      {
        name: 'Latte',
        desc: 'Espresso with steamed milk and a light touch of foam. Warm and comforting.',
        price: 230,
        veg: true,
      },
      {
        name: 'Flat White',
        desc: 'Double ristretto with silky microfoam. Strong, smooth and perfectly balanced.',
        price: 250,
        tag: 'Rare',
        veg: true,
      },
      {
        name: 'Cortado',
        desc: 'Equal parts espresso and warm milk — cuts through the intensity beautifully.',
        price: 210,
        tag: 'Rare',
        veg: true,
      },
      {
        name: 'Filter Coffee',
        desc: 'Traditional South Indian filter coffee, brewed strong and served with frothy milk.',
        price: 180,
        tag: 'Iconic',
        veg: true,
      },
      {
        name: 'Cinnamon Latte',
        desc: 'Espresso with steamed milk and a warm touch of cinnamon. Cosy and aromatic.',
        price: 240,
        veg: true,
      },
      {
        name: 'Mocha',
        desc: 'Espresso with rich chocolate and steamed milk. Comforting and indulgent.',
        price: 250,
        veg: true,
      },
    ],
  },
  {
    id: 'iced-coffee',
    label: 'Iced Coffee',
    items: [
      {
        name: 'Iced Latte',
        desc: 'Espresso over ice with chilled milk. Simple and satisfying.',
        price: 218,
        veg: true,
      },
      {
        name: 'Iced Americano',
        desc: 'Espresso over ice and cold water — clean, bracing, refreshing.',
        price: 200,
        veg: true,
      },
      {
        name: 'Iced Mocha',
        desc: 'Espresso, chocolate sauce, milk, and ice — rich and indulgent.',
        price: 260,
        veg: true,
      },
      {
        name: 'Iced Cappuccino',
        desc: 'Your favourite cappuccino, chilled over ice and topped with cold foam.',
        price: 230,
        veg: true,
      },
    ],
  },
  {
    id: 'other-beverages',
    label: 'Other Beverages',
    items: [
      {
        name: 'Masala Chai',
        desc: 'Hand-blended spiced tea with ginger, cardamom, and whole milk.',
        price: 150,
        tag: 'Iconic',
        veg: true,
      },
      {
        name: 'Hot Chocolate',
        desc: 'Rich chocolate melted into whole milk. Thick, warming, and luxurious.',
        price: 230,
        veg: true,
      },
      {
        name: 'Kombucha',
        desc: 'House-fermented kombucha in seasonal flavours. Light, tangy, and gut-friendly.',
        price: 200,
        tag: 'New',
        veg: true,
      },
    ],
  },
  {
    id: 'salads',
    label: 'Salads',
    items: [
      {
        name: 'Farm Fresh Salad',
        desc: 'Seasonal greens, cherry tomatoes, cucumber, and house vinaigrette.',
        price: 250,
        veg: true,
      },
      {
        name: 'Greek Salad',
        desc: 'Cucumber, olives, feta, and tomatoes with olive oil and oregano dressing.',
        price: 270,
        veg: true,
      },
      {
        name: 'Roasted Vegetable Salad',
        desc: 'Seasonal roasted vegetables with herbs and balsamic glaze.',
        price: 260,
        veg: true,
      },
    ],
  },
  {
    id: 'garlic-breads',
    label: 'Garlic Breads',
    items: [
      {
        name: 'Classic Garlic Bread',
        desc: 'Toasted baguette with garlic butter and herbs.',
        price: 150,
        veg: true,
      },
      {
        name: 'Cheesy Garlic Bread',
        desc: 'Garlic butter baguette loaded with melted cheese.',
        price: 180,
        veg: true,
      },
      {
        name: 'Peri Peri Garlic Bread',
        desc: 'Garlic bread with a spicy peri peri kick and cheese.',
        price: 190,
        veg: true,
      },
    ],
  },
  {
    id: 'appetizer',
    label: 'Appetizers',
    items: [
      {
        name: 'Zucchini Fries',
        desc: 'Crispy fried zucchini sticks seasoned with herbs, served with garlic mayo.',
        price: 220,
        veg: true,
      },
      {
        name: 'Stuffed Mushrooms',
        desc: 'Button mushrooms filled with cheese and herbs, baked to perfection.',
        price: 240,
        veg: true,
      },
      {
        name: 'Cherry Tomato Mozzarella Bruschetta',
        desc: 'Soft baguette with fresh mozzarella, roasted cherry tomatoes, and balsamic vinegar.',
        price: 260,
        veg: true,
      },
      {
        name: 'Cheesy French Fries',
        desc: 'Crinkle-cut fries with cocktail sauce and melted cheese.',
        price: 220,
        veg: true,
      },
      {
        name: 'Fried Cheesy Potato',
        desc: 'Golden fried potato with a gooey cheese centre.',
        price: 318,
        veg: true,
      },
      {
        name: 'Peri Peri Chicken Wings',
        desc: 'Crispy chicken wings tossed in fiery peri peri sauce.',
        price: 310,
        veg: false,
      },
      {
        name: 'Honey Chilli Wings',
        desc: 'Crispy wings glazed with honey chilli sauce — the perfect sweet heat.',
        price: 384,
        tag: 'New',
        veg: false,
      },
      {
        name: 'Fish Fingers',
        desc: 'Breaded basa fish fingers, golden fried and paired with tartar sauce.',
        price: 280,
        veg: false,
      },
    ],
  },
  {
    id: 'sandwiches',
    label: 'Sandwiches',
    items: [
      {
        name: 'BBQ Chicken Sandwich',
        desc: 'Grilled chicken with BBQ sauce and cheese in grilled bread.',
        price: 358,
        veg: false,
      },
      {
        name: 'Paneer Sandwich',
        desc: 'Minced paneer and cheese in grilled bread. Hearty and satisfying.',
        price: 338,
        veg: true,
      },
      {
        name: 'Veg Club Sandwich',
        desc: 'Triple-decker with fresh veggies, cheese, and mayo on toasted bread.',
        price: 300,
        veg: true,
      },
      {
        name: 'Chicken Club Sandwich',
        desc: 'Triple-decker with grilled chicken, lettuce, tomato, and mayo.',
        price: 340,
        veg: false,
      },
    ],
  },
  {
    id: 'burgers',
    label: 'Burgers',
    items: [
      {
        name: 'Pulled Mutton Burger',
        desc: 'Slow-cooked pulled mutton in a fresh bun with slaw and house sauce.',
        price: 416,
        veg: false,
      },
      {
        name: 'Crispy Chicken Burger',
        desc: 'Crispy fried chicken fillet with lettuce, pickles, and chipotle mayo.',
        price: 370,
        veg: false,
      },
      {
        name: 'Veg Burger',
        desc: 'House veggie patty with cheese, lettuce, tomato, and mustard.',
        price: 310,
        veg: true,
      },
    ],
  },
  {
    id: 'pasta',
    label: 'Pasta',
    items: [
      {
        name: 'Mac and Cheese',
        desc: 'Creamy macaroni baked with cheese and topped golden. Pure comfort food.',
        price: 310,
        veg: true,
      },
      {
        name: 'Spaghetti Aglio Olio',
        desc: 'Spaghetti tossed in garlic, olive oil, chilli flakes, and parsley.',
        price: 320,
        veg: true,
      },
      {
        name: 'Penne Arrabbiata',
        desc: 'Penne in spicy tomato sauce with garlic and chilli.',
        price: 290,
        veg: true,
      },
      {
        name: 'Mushroom Pasta',
        desc: 'Pasta with sautéed mushrooms in a creamy herb sauce.',
        price: 320,
        veg: true,
      },
      {
        name: 'Chicken Penne in White Sauce',
        desc: 'Penne with grilled chicken in a rich creamy white sauce.',
        price: 350,
        veg: false,
      },
    ],
  },
  {
    id: 'flat-bread-pizza',
    label: 'Flatbread Pizza',
    items: [
      {
        name: 'Margherita',
        desc: 'Classic tomato base with mozzarella and fresh basil on a crispy flatbread.',
        price: 320,
        veg: true,
      },
      {
        name: 'Farm Fresh Veggie Pizza',
        desc: 'Seasonal vegetables on tomato base with mozzarella and herbs.',
        price: 350,
        veg: true,
      },
      {
        name: 'BBQ Chicken Pizza',
        desc: 'Grilled chicken with BBQ sauce, red onion, and mozzarella.',
        price: 390,
        veg: false,
      },
      {
        name: 'Peri Peri Chicken Pizza',
        desc: 'Spicy peri peri chicken with peppers and cheese on flatbread.',
        price: 390,
        veg: false,
      },
    ],
  },
  {
    id: 'lasagne',
    label: 'Lasagne',
    items: [
      {
        name: 'Veg Lasagna',
        desc: 'Layers of pasta with veggies, cheese, and tomato sauce, baked golden.',
        price: 340,
        veg: true,
      },
      {
        name: 'Mutton Lasagna',
        desc: 'Mutton keema baked with Italian herbs, tomatoes, and melted cheese between pasta layers.',
        price: 390,
        tag: 'Iconic',
        veg: false,
      },
      {
        name: 'Chicken Lasagna',
        desc: 'Layers of pasta with spiced chicken mince, béchamel, and mozzarella.',
        price: 370,
        veg: false,
      },
    ],
  },
  {
    id: 'main-course',
    label: 'Main Course',
    items: [
      {
        name: 'Baked Stuffed Chicken',
        desc: 'Chicken breast stuffed with prawn and cheese, baked with olive oil, basil, and garlic.',
        price: 490,
        tag: 'Iconic',
        veg: false,
      },
      {
        name: 'Mushroom Risotto',
        desc: 'Creamy arborio rice with mushrooms, parmesan, and herbs.',
        price: 370,
        veg: true,
      },
      {
        name: 'Veg Risotto',
        desc: 'Seasonal vegetables in a creamy parmesan risotto.',
        price: 350,
        veg: true,
      },
      {
        name: 'Baked Fish',
        desc: 'Basa fillet baked with exotic vegetables and garlic herb butter.',
        price: 450,
        veg: false,
      },
      {
        name: 'Chicken in Choice of Sauce',
        desc: 'Grilled chicken in your pick of paprika, mushroom, or peri peri sauce.',
        price: 430,
        veg: false,
      },
      {
        name: 'Roasted Vegetables',
        desc: 'Seasonal vegetables roasted with herbs and olive oil. Light and wholesome.',
        price: 290,
        veg: true,
      },
    ],
  },
  {
    id: 'dessert',
    label: 'Desserts',
    items: [
      {
        name: 'Chocolate Brownie with Ice Cream',
        desc: 'Warm fudgy dark chocolate brownie topped with vanilla ice cream.',
        price: 250,
        tag: 'Iconic',
        veg: true,
      },
      {
        name: 'Burnt Basque Cheesecake',
        desc: 'Creamy, caramelised cheesecake with a perfectly burnt top. Rich and indulgent.',
        price: 298,
        tag: 'New',
        veg: true,
      },
      {
        name: 'Tiramisu',
        desc: 'Coffee-soaked ladyfingers layered with mascarpone cream and dusted with cocoa.',
        price: 280,
        veg: true,
      },
    ],
  },
];